function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import useOnClickOutside from '../../../helpers/hooks/useOnClickOutside';
import Input from './Input.react';

// TODO :: consider changing names in options to something that won't be used in database
var Select = function Select(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  var hasPermission = useHasPermission(permission);

  // useOnClickOutside(id, () => setOpen(false));

  useOnClickOutside({
    id: id,
    onClickOutside: function onClickOutside() {
      return setOpen(false);
    }
  });
  useEffect(function () {
    if (open) {
      $("#".concat(id, "-dropdown")).focus();
      setFilter('');
    }
  }, [open]);
  var label = options.filter(function (x) {
    return x.sValue === value;
  })[0];
  var handleOnClick = function handleOnClick(option) {
    onChange(option);
    setOpen(false);
  };

  // useEffect(() => {
  // 	console.log('value did update', value)

  // 	if (value !== $(`${id}-input`).value)
  // 		console.log('we should updata something')
  // }, [value]);
  // console.log('options', options)

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "select ".concat(className)
  }, /*#__PURE__*/React.createElement(Input, {
    id: "".concat(id, "-input")
    // value={label?.sLabel || ''}
    ,
    value: label === null || label === void 0 ? void 0 : label.sLabel,
    disabled: disabled || !hasPermission
    // onChange={handleOnChange}
    ,
    placeholder: placeholder,
    onFocus: function onFocus() {
      if (!disabled) setOpen(true);
    }
    // onFocus={handleOnFocus}
    // onBlur={handleOnBlur}
  }), open && /*#__PURE__*/React.createElement("div", {
    className: "select__dropdown"
  }, /*#__PURE__*/React.createElement("input", {
    id: "".concat(id, "-dropdown"),
    value: filter,
    placeholder: "Search...",
    onChange: function onChange(e) {
      return setFilter(e.target.value.toLowerCase());
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "select__dropdown--content"
  }, options.filter(function (x) {
    var _x$sLabel;
    return (_x$sLabel = x.sLabel) === null || _x$sLabel === void 0 ? void 0 : _x$sLabel.toString().toLowerCase().includes(filter);
  }).map(function (x) {
    // TODO :: add visibility
    // TODO :: add disabled
    // TODO :: add description (subtitle, e.g. settings/meta data/add meta data...)
    // TODO :: add checkbox for multi select

    return /*#__PURE__*/React.createElement("div", {
      className: "select__option",
      onClick: function onClick() {
        if (!x.disabled) handleOnClick(x);
      },
      key: "".concat(id).concat(x.sValue)
    }, x.sLabel);
  }))));
};
export default Select;